import axiosInstance from '../api.service.js';
import constants from '../../constants/constants';

const ENDPOINTORIGIN = "EmployeeAcknowledgementForm/";

const getEmployeeAcknowledgementById = async (id) => await axiosInstance.get(ENDPOINTORIGIN + 'GetEmployeeAcknowledgementFormById?id=' + id, constants.REQUIRE_INTERCEPTORS);

const save = async (model) => await axiosInstance.post(ENDPOINTORIGIN + 'Save', model, constants.REQUIRE_INTERCEPTORS);

const getReportPdf = async (id) => await axiosInstance.get(ENDPOINTORIGIN + 'GetReportPdf?id=' + id, constants.REQUIRE_INTERCEPTORS);


export {
    getEmployeeAcknowledgementById,
    save,
    getReportPdf
}